var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasContent)?_c('UiMarkdown',_vm._b({staticClass:"TextAddon"},'UiMarkdown',{ content: _vm.content },false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }